<div class="page-wrapper"
     [tradeClass]="'is-trade'"
     [elementHeight]="'app'">

    <app-busy-state />

    <router-app-busy-state />

    <page-header #pageHeader
                 [style.display]="isStandalone ? 'none' : 'contents'"
                 [offCanvasState]="offCanvasState" />

    @if (hasHeader) {
    <div [class.page-content]="hasPageContentClass">
        <router-outlet #outlet="outlet" />
    </div>
    }

    <ng-container *ifNotStandalone>
        <ng-container *afterContentInit="'router'">

            <!-- page footer -->
            <ng-container *ifTradeStore>
                <ng-container *ifUrlNotContain="['checkout', 'login']">
                    <page-footer />
                </ng-container>
            </ng-container>

            <ng-container *ifNotTradeStore>
                <ng-container *ifUrlNotContain="['checkout']">
                    <page-footer />
                </ng-container>
            </ng-container>
        </ng-container>
    </ng-container>


    <ng-container *afterContentInit>
        <!-- off canvas menu -->
        <off-canvas-menu [offCanvasState]="offCanvasState"
                         [toggleClass]="'_visible'"
                         [toggleClassBy]="offCanvasState"
                         *ifSize="'MS'" />
        <pwa-back-button *ifStandalone />
        <pwa-bottom-bar *ifStandalone
                        [offCanvasState]="offCanvasState" />
        <basket-add-notice *ifSize="'S'" />
    </ng-container>
</div>
<!-- <cms-toggle></cms-toggle> -->